import { Button, Card, Flex, Typography, theme } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CONTACT } from "../../routes";

const { Title, Paragraph } = Typography;

const SupportSection: React.FC = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Flex style={{ marginTop: token.marginSM }}>
      <Card
        style={{
          maxWidth: 800,
          width: "100%",
          borderRadius: token.borderRadiusLG,
          background: token.colorBgLayout,
        }}
      >
        <Flex vertical gap={token.marginMD}>
          <Title level={4}>{t("subscription_page.need_help_choosing")}</Title>
          <Paragraph>{t("subscription_page.contact_support_text")}</Paragraph>
          <Button type="default" onClick={() => navigate(CONTACT)}>
            {t("subscription_page.contact_support")}
          </Button>
        </Flex>
      </Card>
    </Flex>
  );
};

export default SupportSection;